// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectInput_wrapper__Ed9J1","select":"SelectInput_select__L+auI"};